import React from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const StatItem = ({ end, suffix, label, delay }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <motion.div
      ref={ref}
      className="stat-item"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
    >
      <div className="stat-number">
        {inView ? <CountUp end={end} duration={2} suffix={suffix} /> : '0'}
      </div>
      <div className="stat-label">{label}</div>
    </motion.div>
  );
};

const About = () => {
  const stats = [
    { end: 7, suffix: '+', label: 'Years Experience' },
    { end: 50, suffix: '+', label: 'Projects Delivered' },
    { end: 200, suffix: '+', label: 'Students Mentored' },
  ];

  return (
    <div className="container">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        About Me
      </motion.h2>

      <div className="about-grid">
        <motion.div
          className="about-image"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          IZJ
        </motion.div>

        <motion.div
          className="about-text"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <h2>Passionate About Building Solutions</h2>
          <p>
            I am a Senior Project Manager and Technical Strategist who combines engineering insight with business leadership. Over the past decade, I've led cross-functional teams to deliver healthcare, fintech, and enterprise SaaS products that transform operations and enhance compliance.
          </p>
          <p>
            My journey began in software engineering — designing scalable systems and managing SQL-based platforms — and evolved into leading digital transformation projects in healthcare compliance, enterprise warehousing, and fintech middleware integrations for a leading commercial bank.
          </p>
        </motion.div>
      </div>

      <div className="stats">
        {stats.map((stat, index) => (
          <StatItem
            key={index}
            end={stat.end}
            suffix={stat.suffix}
            label={stat.label}
            delay={index * 0.15}
          />
        ))}
      </div>
    </div>
  );
};

export default About;